import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
  palette: {
    secondary: {
      main: '#fff',
    },
    background: {
      cardBg: 'rgb(59, 60, 67)',
    }
  }
});